<div class="tds-u-h-100 tds-u-w-100 tds-u-overflow-hidden">
  <div class="tds-u-flex tds-u-h-100 tds-u-w-100">
    <div class="welcome-panel tds-u-flex tds-u-justify-center tds-u-items-center">
      <div class="welcome-content">
        <h2>{{ 'login.welcomeBack' | translate }}</h2>
        <p>{{ 'login.description' | translate }}</p>
        <div class="stats tds-u-flex tds-u-justify-center tds-u-gap4">
          <div class="stat-item">
            <h3>150+</h3>
            <p>{{ 'login.testVehicles' | translate }}</p>
          </div>
          <div class="stat-item">
            <h3>24/7</h3>
            <p>{{ 'login.monitoring' | translate }}</p>
          </div>
          <div class="stat-item">
            <h3>50+</h3>
            <p>{{ 'login.engineers' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="login-panel login-panel tds-u-align-center tds-u-flex tds-u-justify-center">
      <div class="login-content">
        <div class="login-header">
          <h1 class="logo">R&D<span class="logo-asia">ASIA</span></h1>
          <p class="title">{{ 'login.systemTitle' | translate }}</p>
        </div>
        <div class="login-body">
          <div class="language-switcher tds-u-mb3">
            <a
              href="#"
              (click)="switchLanguage('en'); $event.preventDefault()"
              [class.active]="currentLanguage() === 'en'"
              class="lang-link"
            >
              English
            </a>
            <span class="separator">|</span>
            <a
              href="#"
              (click)="switchLanguage('zh'); $event.preventDefault()"
              [class.active]="currentLanguage() === 'zh'"
              class="lang-link"
            >
              中文
            </a>
          </div>
          <tds-button
            class="sso-button"
            type="button"
            variant="primary"
            size="lg"
            fullbleed
            [text]="'login.singleSignOn' | translate"
            (click)="login('cn')"
          ></tds-button>
        </div>
      </div>
    </div>
  </div>
</div>